export class BuiltInParametersHelper {
    public static BuiltInParameters: string[] = ['{{tag_width}}', '{{tag_height}}'];
}
